import * as types from '../actions/types';
import {GET_COURSE_BOOKS_REQUEST_COMPLETED} from "../actions/types";

const initialState = {
  list: null,
  isLoading: false,
  isError: false,
};

export default function courseBooks(state = initialState, action) {
  switch (action.type) {
    case GET_COURSE_BOOKS_REQUEST_COMPLETED:
      return {
        list: action.data,
        isLoading: false,
        isError: false,
      };

    default:
      return state;
  }
}
